// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__11Gxf","filesListContainer":"PosDisputesFiles_filesListContainer__3JcUb","filesButton":"PosDisputesFiles_filesButton__3zk-W"};